import React, { Component } from "react";
import Swipe from 'react-swipe-component';
import ScrollableAnchor from 'react-scrollable-anchor'

import "./Footer.scss"

class Footer extends Component {
  constructor() {
    super();
    this.shareBTN = this.shareBTN.bind(this);
    this.state = {
      isSlideLeft: false
    }
    this.onSwipeLeftListener = this._onSwipeLeftListener.bind(this);
    this.onSwipeRightListener = this._onSwipeRightListener.bind(this);
    this.onSwipeDownListener = this._onSwipeUpListener.bind(this);
    this.onSwipeUpListener = this._onSwipeDownListener.bind(this);
    this.onSwipeListener = this._onSwipeListener.bind(this);
    this.isMobile = this.isMobile.bind(this);
  }
  isMobile() {
    if (navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Windows Phone/i)
    ) {
      return true;
    } else {
      return false;
    }
  }
  _onSwipeLeftListener() {
    //console.log("Swiped left");
    this.setState({
      isSlideLeft: true
    })
    window.dataLayer.push({
      'event': 'GA_Event',
      'Category': 'Vaseline',
      'Action': 'Cupon_Shaved',
      'Label': ""
    });
    // var elem = window.document.getElementById('goToKupon');
    // elem.addEventListener('click', () => {
    //   //window.open("https://unilever-coupons.co.il/category/brands/%D7%95%D7%95%D7%96%D7%9C%D7%99%D7%9F/?utm_source=ynet&utm_medium=banner&utm_campaign=vaseline-men_jan2018&utm_content=ynet_coupon", "_blank");
    //   window.open("http://bit.ly/2BlL4Ty", "_blank");
    // });
    window.setTimeout(() => {
      // var elem = window.document.getElementById('goToKupon');
      // var event = new Event('click');
      // elem.dispatchEvent(event);
      //window.open("http://bit.ly/2BlL4Ty", (this.isMobile() ? "_parent" : "_new"));
      window.open("https://shop.super-pharm.co.il/vaseline?utm_source=unilever&utm_medium=banner&utm_campaign=vaseline-men_jan2018&utm_content=ynet_content_button", "_parent");
    }, 500);
    window.setTimeout(() => {
      this.setState({
        isSlideLeft: false
      })
    }, 1500)
  }
  _onSwipeRightListener() {
    //console.log("Swiped right");
  }
  _onSwipeUpListener() {
    // console.log("Swiped Up");
  }
  _onSwipeDownListener() {
    //  console.log("Swiped down");
  }
  _onSwipeListener(e) {
    //    if (e[1] === 0) console.log("Swipe x: " + e[0]);
    //   else if (e[0] === 0) console.log("Swipe y: " + e[1]);
  }
  componentDidMount() {
    /*
    window.onscroll = function (ev) {
      if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
        window.dataLayer.push({
          'event': 'GA_Event',
          'Category': 'Vaseline',
          'Action': 'Navigation',
          'Label': "Reached Bottom of Site"
        });
      }
    }
    */
  }
  shareBTN(action) {
    var url = "https://z.ynet.co.il/short/commerce/2018/vaseline/";
    switch (action) {
      default:
      case "facebook":
        window.dataLayer.push({
          'event': 'GA_Event',
          'Category': 'Vaseline',
          'Action': 'Share_Facebook',
          'Label': window.location.href
        });
        window.open("http://www.facebook.com/share.php?u=" + encodeURIComponent(url) + "&redirect_uri=" + encodeURIComponent(url), "_blank");
        break;
      case "whatsapp":
        window.dataLayer.push({
          'event': 'GA_Event',
          'Category': 'Vaseline',
          'Action': 'Share_WhatsApp',
          'Label': window.location.href
        });
        window.open("whatsapp://send?text=" + encodeURIComponent("גבר, יש מצב שאתה יבש? כנס ובדוק עכשיו >> " + url), "_parent");
        break;
      case "email":
        window.dataLayer.push({
          'event': 'GA_Event',
          'Category': 'Vaseline',
          'Action': 'Share_Mail',
          'Label': window.location.href
        });
        var shareText = "גבר, יש מצב שאתה יבש? כנס ובדוק עכשיו";
        window.open("mailto:?subject=" + encodeURIComponent(window.document.title) + "&body=" + encodeURIComponent(shareText + " הקליקו >> " + url), "_parent");
        break;
      case "negishut":
        var elem = window.document.getElementById('INDmenu-btn');
        var event = new Event('click');
        elem.dispatchEvent(event);
        break;
      case "sharer":
        this.setState({
          isActive: (this.state.isActive === 1 ? 0 : 1)
        });
        break;
    }
  }
  render() {
    return (
      <footer>
        <a className="goToKupon" id="goToKupon" href="https://unilever-coupons.co.il/category/brands/vaseline/?utm_source=ynet&utm_medium=banner&utm_campaign=vaseline-men_jan2018&utm_content=ynet_coupon" title="" target="_blank"></a>
        <ScrollableAnchor id={`section5`}>
          <div id="footer">
            <Swipe
              nodeName="div"
              className={`opener ${(this.state.isSlideLeft ? "active" : "")}`}
              mouseSwipe={true}
              onSwipedLeft={this.onSwipeLeftListener}
              onSwipedRight={this.onSwipeRightListener}
              onSwipedDown={this.onSwipeDownListener}
              onSwipedUp={this.onSwipeUpListener}
              onSwipe={this.onSwipeListener}>
              <div className="bottle"></div>
              <div className="dots right">
                <div className="movearrow">
                  <div className="circle"></div>
                  <div className="arrowleft"></div>
                </div>
                <div className="dot"></div>
                <div className="dot"></div>
              </div>
              <div className="textslide">לרכישת המוצר, החלק כאן</div>
              <div className="dots left">
                <div className="dot hide"></div>
                <div className="dot hide"></div>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
              </div>
            </Swipe>
            <div className="padding">
              <div className="rightside">
                <div onClick={() => { this.shareBTN("email") }} className={"share email "}></div>
                <div onClick={() => { this.shareBTN("facebook") }} className={"share fb "}></div>
                <div onClick={() => { this.shareBTN("whatsapp") }} className={"share ws "}></div>
              </div>
              <div className="leftside">
                <div className="logo"></div>
              </div>
              <div className="middlelogo">
                <a href="//www.yit.co.il/?utm_source=vaseline" title="YIT" target="_blank" rel="noopener noreferrer">
                  <div className="text">פיתוח</div>
                  <div className="logo"></div>
                </a>
              </div>
            </div>
          </div>
        </ScrollableAnchor>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Components/Footer/Footer.js